import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedChinaDomesticStep =
  () => import(/* webpackChunkName: "china-domestic-step.async" */ './china-domestic-step')
    .then(({ ChinaDomesticStepWithI18n }) => ChinaDomesticStepWithI18n);

export const ChinaDomesticStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CHINA_DOMESTIC,
  view: DelayedChinaDomesticStep,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
